<template>
  <template v-if="hasHeader">
    <div class="app-container">
      <div class="app-container-content" id="app-container-content">
        <router-view></router-view>
      </div>
    </div>
  </template>
  <template v-else>
    <router-view></router-view>
  </template>
</template>
<script setup>
import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";
const route = useRoute();
/**
 * 页面是否显示头部
 */
const hasHeader = computed(() => {
  const noHeaderRoutes = [null, "Login"];
  return !noHeaderRoutes.includes(route.name);
});

onMounted(() => {
});
</script>
<style lang="less">
#app {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: absolute;
  left: 0;
  top: 0;
}
.app-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .app-container-content {
      flex: 1;
      height: 0;
      overflow-y: auto;
    }
  }
</style>